export const ENTITY_CARD_SIZES = '(max-width: 640px) 80vw, (max-width: 1024px) 40vw, 280px';
export const MAP_CARD_SIZES = '280px';
export const GALLERY_MAIN_SIZES = '(max-width: 768px) 100vw, 50vw';
export const GALLERY_GRID_SIZES = '(max-width: 768px) 50vw, 25vw';
export const GALLERY_THUMB_SIZES = '(max-width: 768px) 50vw, 80px';
export const THUMBNAIL_SIZES = '(max-width: 768px) 40vw, 120px';

